import {defineComponent, onMounted, ref} from "vue"
import {useRouter} from 'vue-router'
import axios from "axios"
import CourseCard from '../../components/courses/CourseCard.vue'
import Subscribe from '../subscription/Subscribe.vue'
import BaseCard from '../../components/ui/BaseCard.vue'
import Utils from "@/views/shared/Utils";
import {CourseType} from "@/types/CourseType"
import MilitaryDiscipline from "@/types/MilitaryDiscipline"
import CivilianTrainingArea from "@/types/CivilianTrainingArea"
import SearchParameters from "@/types/SearchParameters"
import Topic from "@/types/Topic"
import {CourseLite} from "@/types/CourseLite";
import {useSearchParametersStore} from "@/stores/searchParametersStore";

export default defineComponent({
    name: "home-page",
    components: {
        BaseCard,
        CourseCard,
        Subscribe
    },
    computed: {
        registrarUrl() {
            return localStorage.getItem('registrarUrl') || "/registrar/web"
        }
    },
    setup() {

        const router = useRouter();
        const searchParametersStore = useSearchParametersStore();

        const allTypes = Utils.enumToObject(CourseType);
        const searchParameters = ref(SearchParameters.getNew());
        const allTopics = ref([] as Topic[]);
        const militaryDisciplinesPrimaries = ref([] as MilitaryDiscipline[]);
        const militaryDisciplinesAll = ref([] as MilitaryDiscipline[]);
        const civilianTrainingAreasPrimaries = ref([] as CivilianTrainingArea[]);
        const civilianTrainingAreasAll = ref([] as CivilianTrainingArea[]);
        const showEUCTContent = ref(false);
        const showMDPContent = ref(false);
        const coursesLastCall = ref([] as CourseLite[]);

        onMounted(async () => {

            const topicsResp = await axios.get("api/search/topics");
            if (topicsResp.status == 200 && topicsResp.data != null) {
                const data: any[] = topicsResp.data; // Type assertion to any[]
                const filteredData = data.filter((item) => item.write === true && item.description != 'Other')
                filteredData.forEach(item => {
                    allTopics.value.push(Topic.fromResponse(item))
                })
            }

            const milDiscResp = await axios.get("api/search/militaryDisciplines");
            if (milDiscResp.status == 200 && milDiscResp.data != null) {
                const data: any[] = milDiscResp.data; // Type assertion to any[]

                data.filter((item) => item.write === true && item.sortPriority === true)
                    .sort((a, b) => Utils.compareStrings(a.name, b.name))
                    .forEach(item => {
                        militaryDisciplinesPrimaries.value.push(MilitaryDiscipline.fromResponse(item));
                    });

                data.filter((item) => item.write === true)
                    .sort((a, b) => Utils.compareStrings(a.name, b.name))
                    .forEach(item => {
                        militaryDisciplinesAll.value.push(MilitaryDiscipline.fromResponse(item));
                    });
            }

            const civilianTraAreasResp = await axios.get("api/search/civilianTrainingAreas");
            if (civilianTraAreasResp.status == 200 && civilianTraAreasResp.data != null) {
                const data: any[] = civilianTraAreasResp.data; // Type assertion to any[]
                data.filter((item) => item.write === true && item.sortPriority === true)
                    .sort((a, b) => Utils.compareStrings(a.name, b.name))
                    .forEach(item => {
                        civilianTrainingAreasPrimaries.value.push(CivilianTrainingArea.fromResponse(item));
                    });

                data.filter((item) => item.write === true)
                    .sort((a, b) => Utils.compareStrings(a.name, b.name))
                    .forEach(item => {
                        civilianTrainingAreasAll.value.push(CivilianTrainingArea.fromResponse(item));
                    });
            }

            const lastCallResp = await axios.get("api/search/courses/lastCall");
            if (lastCallResp.status == 200 && lastCallResp.data != null) {
                coursesLastCall.value = [];
                lastCallResp.data.forEach((item: any) => {
                    coursesLastCall.value.push(CourseLite.fromResponse(item));
                });
            }

        })


        async function search() {

            console.log(searchParameters.value);
            searchParametersStore.setSearchParameters(searchParameters.value);
            await router.push({name: 'Search'});

        }

        async function onTextFieldKeyPress(event: any) {

            if (event.key === "Enter") {
                await search();
            }

        }

        const toggleCtaSubtopics = () => {
            showEUCTContent.value = !showEUCTContent.value;
            const euctContainer = document.getElementById('euctContainer');
            if(euctContainer && showEUCTContent.value === false) {
                window.scrollTo({
                    behavior: 'auto',
                    top:
                        euctContainer.getBoundingClientRect().top -
                        document.body.getBoundingClientRect().top -
                        150,
                })
            }
        }

        const toggleMtdSubtopics = () => {
            showMDPContent.value = !showMDPContent.value
            const mdpContainer = document.getElementById('mdpContainer');
            if(mdpContainer && showMDPContent.value === false) {
                window.scrollTo({
                    behavior: 'auto',
                    top:
                        mdpContainer.getBoundingClientRect().top -
                        document.body.getBoundingClientRect().top -
                        150,
                })
            }
        }


        return {
            searchParameters,
            allTypes,
            allTopics,
            militaryDisciplinesPrimaries,
            militaryDisciplinesAll,
            civilianTrainingAreasPrimaries,
            civilianTrainingAreasAll,
            toggleCtaSubtopics,
            showEUCTContent,
            toggleMtdSubtopics,
            showMDPContent,
            coursesLastCall,
            search,
            onTextFieldKeyPress
        }
    }
})